<template>
  <el-dialog
    :title="'Quản lý khóa phòng'"
    :visible.sync="dialogIssueCardVisible"
    width="70%"
    append-to-body
    :close-on-click-modal="false"
    @close="() => {}"
  >
    <div v-loading="dialogLoading" class="das-form-container datnt">
      <div class="das-form-group">
        <div class="das-form-group-title">
          {{ 'Danh sách khóa mặc định (miễn phí)' }}
        </div>
        <div class="grid-scroll mt-10">
          <GridVx
            ref="freeCardTable"
            v-loading="gridLoading"
            dom-layout="autoHeight"
            :context="context"
            :columns="freeCardCols"
            :rows="freeCardRows"
            class="agGrid"
            :auto-size-cell="true"
            :auto-select-first-row="false"
          />
        </div>
      </div>

      <div class="das-form-group">
        <div class="das-form-group-title">
          {{ 'Danh sách khóa dịch vụ' }}
        </div>
        <div class="grid-scroll mt-10">
          <GridVx
            ref="addCardTable"
            v-loading="gridLoading"
            dom-layout="autoHeight"
            :context="context"
            :columns="addCardCols"
            :rows="addCardRows"
            class="agGrid"
            :auto-size-cell="true"
            :auto-select-first-row="false"
          />
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="dialogIssueCardVisible = false"
        >
          {{ 'Đóng' }}
        </button>
        <button class="btn primary small" @click="onUpdate">
          {{ 'Cập nhật' }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
/* eslint-disable */
import CellRenderCardNumberInput from './CellRenderCardNumberInput.vue'
import { CellRenderCalendarSelectForTable } from '@/utils/groupCellRenders.js'
import { CellRenderDeleteIcon } from '@/utils/cellRenders.js'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'

import {
  getCardRoomByBookingId,
  deleteCardRoom,
  cacheCardsToRoom
} from '@/api/reception/card_service'
import { checkRunningTask } from '@/api/task.js'
import { datetimeUserToDev } from '@/utils/commonUtils'
export default {
  components: {
    CellRenderCardNumberInput,
    CellRenderCalendarSelectForTable,
    CellRenderDeleteIcon,
    CellRenderCheckboxReadonly
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      context: null,
      freeCardRows: [],
      addCardRows: [],
      freeCardQuantity: null,
      addCardQuantity: null,

      freeCardCols: [
        {
          headerName: 'Số thẻ',
          field: 'card_number',
          tooltipField: 'card_number',
          minWidth: 100,
          // headerClass: 'header-row-span-2',
          cellRenderer: 'CellRenderCardNumberInput',
          cellRendererParams: params => {
            return {
              refName: 'freeCard',
              disabled: params.data?.card_id ? true : false
            }
          }
        },
        {
          headerName: 'Từ',
          tooltipField: 'start_date',
          field: 'start_date',
          cellRenderer: 'CellRenderCalendarSelectForTable',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'start_date',
              clearable: true,
              dateType: 'datetime',
              format: 'dd/MM/yyyy HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              refName: 'freeCard'
            }
          },
          minWidth: 150,
          maxWidth: 250
        },
        // format: 'dd/MM/yyyy HH:mm:ss',
        // valueFormat: 'yyyy-MM-dd HH:mm:ss'
        {
          headerName: 'Đến',
          tooltipField: 'end_date',
          field: 'end_date',
          headerClass: 'last-header-cell-group',
          cellRenderer: 'CellRenderCalendarSelectForTable',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'end_date',
              clearable: true,
              dateType: 'datetime',
              format: 'dd/MM/yyyy HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              refName: 'freeCard'
            }
          },
          minWidth: 150,
          maxWidth: 250
        },
        {
          headerName: 'Đã phát hành',
          field: 'is_issued',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCheckboxReadonly',
          width: 80
        },
        {
          headerName: '',
          // headerClass: ['header-row-span-2', 'header-cell-suffix-group'],
          width: 50,
          cellRenderer: 'CellRenderDeleteIcon',
          cellRendererParams: params => {
            return {
              refName: 'freeCard',
              disabled: params.data?.card_id ? true : false
            }
          },
          cellStyle: () => {
            return {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          }
        }
      ],
      addCardCols: [
        {
          headerName: 'Số thẻ',
          field: 'card_number',
          tooltipField: 'card_number',
          minWidth: 100,
          // headerClass: 'header-row-span-2',
          cellRenderer: 'CellRenderCardNumberInput',
          cellRendererParams: params => {
            return {
              refName: 'addCard',
              disabled: params.data?.card_id ? true : false
            }
          }
        },
        {
          headerName: 'Từ',
          tooltipField: 'start_date',
          field: 'start_date',
          cellRenderer: 'CellRenderCalendarSelectForTable',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'start_date',
              clearable: true,
              dateType: 'datetime',
              format: 'dd/MM/yyyy HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              refName: 'addCard'
            }
          },
          minWidth: 150,
          maxWidth: 250
        },
        // format: 'dd/MM/yyyy HH:mm:ss',
        // valueFormat: 'yyyy-MM-dd HH:mm:ss'
        {
          headerName: 'Đến',
          tooltipField: 'end_date',
          field: 'end_date',
          cellRenderer: 'CellRenderCalendarSelectForTable',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'end_date',
              clearable: true,
              dateType: 'datetime',
              format: 'dd/MM/yyyy HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              refName: 'addCard'
            }
          },
          minWidth: 150,
          maxWidth: 250
        },
        {
          headerName: 'Đã phát hành',
          field: 'is_issued',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCheckboxReadonly',
          width: 80
        },
        {
          headerName: '',
          // headerClass: ['header-row-span-2', 'header-cell-suffix-group'],
          width: 50,
          cellRenderer: 'CellRenderDeleteIcon',
          cellRendererParams: params => {
            return {
              refName: 'addCard',
              disabled: params.data?.card_id ? true : false
            }
          },
          cellStyle: () => {
            return {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          }
        }
      ],

      freeCardLoading: false,
      addCardLoading: false,
      gridLoading: false,

      // dialog
      dialogLoading: false,
      interval: null
    }
  },

  computed: {
    dialogIssueCardVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.selectedBooking = { ...this.data }
        this.$emit('input', val)
      }
    }
  },

  watch: {
    data(nv, ov) {
      if (nv?.sub_booking_group_id) {
        // this.fnGetCardRoomDetail(nv?.sub_booking_group_id)
      }
    },
    value(nv, ov) {
      if (nv && this.data?.sub_booking_group_id) {
        this.interval = setInterval(async () => {
          this.dialogLoading = await checkRunningTask(
            this.data?.sub_booking_group_id,
            'BOOKING'
          )
          if (this.dialogLoading === false) {
            clearInterval(this.interval)
          }
        }, 1 * 1000)

        this.fnGetCardRoomDetail(this.data?.sub_booking_group_id)
      }
    }
  },

  beforeMount() {
    this.context = { componentParent: this }
  },

  methods: {
    // util validate...
    valid(req) {
      var isValid = true
      for (var i = 0; i < req.length; i++) {
        if (req[i].start_date === null || req[i].end_date === null) {
          isValid = false
          break
        } else {
          if (
            // this.$moment(req[i].start_date).isBefore(
            //   this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
            // ) ||
            this.$moment(req[i].start_date).isAfter(req[i].end_date)
          ) {
            isValid = false
            break
          }
        }
      }
      return isValid
    },

    // handle event
    changeInput(colName, params, value) {
      // if value exist => return bao loi
      if (
        this.freeCardRows.some(item => item.card_number === value) ||
        this.addCardRows.some(item => item.card_number === value)
      ) {
        this.$message({
          type: 'error',
          message: 'Thẻ đã tồn tại. Vui lòng nhập thẻ khác!'
        })
        if (params.refName === 'freeCard') {
          this.freeCardRows.splice(params.rowIndex, 1, {
            card_number: null,
            start_date: params.data?.start_date,
            end_date: params.data?.end_date,
            is_issued: false,
            operation_type: 2,
            card_id: null
          })
        } else if (params.refName === 'addCard') {
          this.addCardRows.splice(params.rowIndex, 1, {
            card_number: null,
            start_date: params.data?.start_date,
            end_date: params.data?.end_date,
            is_issued: false,
            operation_type: 1,
            card_id: null
          })
        }
        return
      }

      if (params.refName === 'freeCard') {
        this.freeCardRows[params.rowIndex][colName] = value
      } else if (params.refName === 'addCard') {
        this.addCardRows[params.rowIndex][colName] = value
      }
    },
    changeCalendar(params, value, colName) {
      if (params.refName === 'freeCard') {
        this.freeCardRows[params.rowIndex][colName] = value
      } else if (params.refName === 'addCard') {
        this.addCardRows[params.rowIndex][colName] = value
      }
    },
    onDeleteIconClicked(params) {
      if (params.disabled) {
        // call delete api
        if (
          !this.fnDeleteCardRoomDetail(
            params.data?.room_id,
            params.data?.card_number
          )
        ) {
          return
        }
      }
      if (params.refName === 'freeCard') {
        this.freeCardRows.splice(params.rowIndex, 1, {
          card_number: null,
          start_date: null,
          end_date: null
        })
      }
      if (params.refName === 'addCard') {
        this.addCardRows.splice(params.rowIndex, 1, {
          card_number: null,
          start_date: null,
          end_date: null
        })
      }
    },

    onUpdate() {
      // validate input
      // var req = this.roomRows.filter(item => {
      //   return item.card_number_start_date || item.card_number_end_date
      // })

      const formData = {
        room_id: this.data?.room_id,
        booking_id: this.data?.sub_booking_group_id,
        card_list: this.freeCardRows.filter(
          item => item.card_number && item.start_date && item.end_date
        ),
        card_list_add: this.addCardRows.filter(
          item => item.card_number && item.start_date && item.end_date
        )
      }
      if (
        !this.valid(formData.card_list) ||
        !this.valid(formData.card_list_add)
      ) {
        this.$message({
          type: 'error',
          message: 'Vui lòng xem lại thời gian hiệu lực!'
        })
        return
      }

      // call api update
      this.fnUpdateCardsToRoom(formData)
    },

    // handle api call
    fnGetCardRoomDetail(bookingId) {
      this.gridLoading = true
      getCardRoomByBookingId(bookingId)
        .then(res => {
          this.freeCardRows = res.data.free_card_list
          this.addCardRows = res.data.added_card_list
          this.freeCardQuantity = res.data.free_card_quantity
          this.addCardQuantity = res.data.added_card_quantity

          if (this.freeCardQuantity > this.freeCardRows.length) {
            let n = this.freeCardQuantity - this.freeCardRows.length
            for (let i = 0; i < n; i++) {
              this.freeCardRows.push({
                card_number: null,
                start_date: datetimeUserToDev(this.data?.arrive_date),
                end_date: datetimeUserToDev(this.data?.depart_date)
              })
            }
          }

          if (this.addCardQuantity > this.addCardRows.length) {
            let n = this.addCardQuantity - this.addCardRows.length
            for (let i = 0; i < n; i++) {
              this.addCardRows.push({
                card_number: null,
                start_date: datetimeUserToDev(this.data?.arrive_date),
                end_date: datetimeUserToDev(this.data?.depart_date),
                is_issued: false
              })
            }
          }
        })
        .catch(error => {
          console.error(error)
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.gridLoading = false
        })
    },
    fnDeleteCardRoomDetail(roomId, cardNumber) {
      this.$vxConfirm(
        'Bạn chắc chắn muốn xóa khóa này? Danh sách khóa sẽ được cập nhật!',
        () => {
          this.gridLoading = true
          deleteCardRoom(roomId, cardNumber)
            .then(res => {
              if (!res.is_error) {
                this.$message({
                  message: res.message,
                  type: 'success'
                })

                this.fnGetCardRoomDetail(this.data?.sub_booking_group_id)
                return true
              } else {
                throw new Error(res)
              }
            })
            .catch(error => {
              this.$message({
                message: error.response?.data?.message,
                type: 'error'
              })
              return false
            })
            .finally(() => {
              this.gridLoading = false
            })
        }
      )
    },
    fnUpdateCardsToRoom(data) {
      this.gridLoading = true
      cacheCardsToRoom(data)
        .then(res => {
          if (!res.is_error) {
            this.$message({
              message: res.message,
              type: 'success'
            })

            this.fnGetCardRoomDetail(this.data?.sub_booking_group_id)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.gridLoading = false
          this.dialogIssueCardVisible = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.das-form-container.datnt > * + * {
  margin: 2rem 0;
}
</style>
